<template>
	<div class="home">
		<div class="top d-flex" middle>
			<div class="flex-1" autowidth @click='$router.push("/user/address/list")'>
				<div>
					<van-icon name="location" size='18px' class="mr-5" color='grey' />
					<span class="fz15 f-color2">当前地址</span>
				</div>
				<div class="pl-25 f-main fz14" v-if='user.communityCode'>{{ user.communityName }}</div>
				<div class="pl-25 f-color4 fz14" v-else>为了提供更好的服务，请先完善地址</div>
			</div>
			<div class="d-flex" v-if="user.token" center middle>
				<van-image round :src="user.avatar || '/static/images/boy.svg'"></van-image>
				<div class="ml-5 f-color3">
					<div class="fz14">{{user.nickName}}</div>
					<div>
						<van-icon name="manager" color='#DDDDDD' size='14px' />
						<span class="ml-5 f-color3 fz12">{{user.gender?'男':'女'}}</span>
					</div>
				</div>
			</div>
			<template v-else>
				<van-image round src="/static/images/user.svg" @click="$login"></van-image>
			</template>
		</div>
		<van-swipe class="my-swipe " :autoplay="3000" indicator-color="white">
			<van-swipe-item>
				<div class="subject">
					<van-image class="banner" src='/static/images/b1.png'></van-image>
					<!-- <p class="f-color2">
						<b>"MAZ智联场景"</b>是MAZ智联场景为响应上海市政府号召而发起的“15分钟生活圈”活动，由<b>"随申办智能物联"</b>委托，打造的社区数字生活服务平台，旨在通过联合各个优质业务生态，并进行监督管理，提供优质服务和产品，提高居民生活服务质量。
					</p> -->
				</div>
			</van-swipe-item>
			<van-swipe-item>
				<div class="subject">
					<van-image class="banner" src='/static/images/qinren.png'></van-image>
					<!-- <p class="f-color2">
						<b>"勤人公社"</b>作为一个以社区为主体开展服务的生活APP，发挥着多元化的作用。为企业或居民秒级匹配精英人才，为应届毕业生、退伍军人和社区退休再就业人员搭建就业或创业渠道；为居民设置邻里互助按钮，构建温暖有爱的社区生活网络。
					</p> -->
				</div>
			</van-swipe-item>
		</van-swipe>
		<div class="d-flex blocks">
			<div class="flex-1 block-item street ready">
				<div class="d-flex" middle>
					<span class="flex-1 wf-zy fz14">街道</span>
					<van-icon name="volume" class='flash'  />
				</div>
				<!-- <div class="spec lineclamp4">
					广富林街道，隶属上海市松江区，地处松江区中北部，东与中山街道连接，南与方松街道相邻，西与小昆山镇相接，西北与佘山镇接壤，北与洞泾镇毗连。区域总面积约19.05平方千米。 2020年，广富林街道常住人口9.7万人（不含大学城）
				</div> -->
			</div>
			<div class="flex-1 block-item committee ml-5 mr-5 ready">
				<div class="d-flex" middle>
					<span class="flex-1 wf-zy fz14">居委</span>
					<van-icon name="volume" class='flash' />
				</div>

			</div>
			<div class="flex-1 block-item property ready">
				<div class="d-flex" middle>
					<span class="flex-1 wf-zy fz14">物业</span>
					<van-icon name="volume" class='flash' />
				</div>

			</div>
		</div>
		<div class="menu-bar d-flex  pb-10">
			<div class="d-flex flex-1  p-10 baritem">
				<div class=" flex-1 tcenter">
					<div class="avatar d-flex" middle center>
						<div class="plus">
							<van-icon name="plus" />
							<div class="fz10 text">招募中</div>
						</div>
						<!-- <van-image class="avatar" round></van-image> -->
					</div>
					<div class=" fz14 mt-5 wf-zy">社区管家</div>
				</div>
				<div class=" flex-1 tcenter ml-10">
					<div class="avatar d-flex" center middle>
						<div class="plus">
							<van-icon name="plus" />
							<div class="fz10 text">招募中</div>
						</div>
						<!-- <van-image class="avatar" round></van-image> -->
					</div>
					<div class=" fz14 mt-5 wf-zy">楼栋组长</div>
				</div>
			</div>
			<div class="flex-1 ml-5 p-10 baritem d-flex" column center>
				<div class="fz14">我的订单</div>
				<div class="d-flex flex-1" @click='$router.push("/order/list")'>
					<div class="flex-1 d-flex" column center middle>
						<div class="fz14 mt-5"><van-icon name="underway-o" size='16px' color='#c79433' /> 进行中</div>
						<b class="fz18 mt-5">0</b>
					</div>
					<div class="flex-1 d-flex" column center middle>
						<div class="fz14 mt-5"><van-icon name="passed" size='16px' color='#c79433' /> 已完成</div>
						<b class="fz18 mt-5">0</b>
					</div>
				</div>
			</div>
		</div>
		<div class="apps">
			<router-view></router-view>
		</div>
		<div class="bottom d-flex" middle>
			<div class="logos">
				<van-image src='/static/images/ssb.png'></van-image>
				<van-image src='/static/images/sscisa.png' class="sscisa"></van-image>
				<van-image src="/static/images/maz.jpg"></van-image>
			</div>
			<div class="flex-1 text">
				<div class="text1">15分钟生活圈</div>
				<div class="text2">上海随申办 • 智能物联 • MAZ智联场景</div>
			</div>
		</div>
		<br>
		<br>
		<br>
		<br>
		<br>
		<br>
		<br>
		<br>
		<br>
		<br>
	</div>
</template>
<script>
	import { mapModules, mapRules } from "vuet";
	export default {
		name: "home",
		mixins: [
			mapModules({
				data: "root/home",
			}),
			mapRules({
				router: "root/home",
			}),
		],
		data() {
			return {
				active: "home",
				user: this.$config.userinfo,
			};
		},
		computed: {},
		methods: {},
		watch: {
			$route() {
				this.active = this.$route.meta["page"];
			},
		},
		mounted() {
			this.active = this.$route.meta["page"];
		},
	};
</script>
<style lang='less'>
.home {
	width: 100%;
	height: 100%;
	overflow-y: auto;

	background-image: url("/static/images/bg.jpg");

	.top {
		background-color: white;
		padding: 5px 10px;

		.van-icon {
			vertical-align: middle;
		}

		.van-image {
			width: 45px;
			height: 45px;
			background-color: #eeeeee;
		}
	}

	.menu-bar {
		padding-left: 10px;
		padding-right: 10px;
		background-color: white;
		.avatar {
			width: 50px;
			height: 50px;
			border-radius: 50%;
			background-color: #eddfc3;
			margin: auto;

			.van-image {
				width: 100%;
				height: 100%;
			}
		}

		.baritem {
			border-radius: 5px;
			background-color: #f4e8d2;
			color: #c79433;
		}
	}

	.f-red {
		color: rgb(172, 13, 13);
	}

	.blocks {
		padding: 0px 10px;
		padding-bottom: 5px;
		background-color: white;

		.block-item {
			padding: 10px;
			border-radius: 5px;
			height: 110px;
			.spec {
				text-indent: 2em;
				margin: 5px 0px;
				font-size: 13px;
				line-height: 18px;
			}

			& > div {
				position: relative;
				z-index: 1;
			}

			&.ready {
				position: relative;
				&::after {
					content: "筹备中...";
					display: inline-block;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					z-index: 1;
					font-size: 12px;
					color:grey;
				}
			}

			&.street {
				background-image: linear-gradient(-225deg, #20e2d7, #f9fea5);

				position: relative;
				overflow: hidden;
				&::before {
					content: " ";
					position: absolute;
					top: 40%;
					left: 40%;
					width: 100%;
					height: 100%;
					background: url(/static/images/street.svg) no-repeat;
					background-size: 70%;
					opacity: 0.3;
				}

				.van-icon {
					color: #158a85;
				}
			}

			&.committee {
				background-image: linear-gradient(90deg, #f9d423 0, #ff4e50);

				position: relative;
				overflow: hidden;
				&::before {
					content: " ";
					position: absolute;
					top: 50%;
					left: 50%;
					width: 100%;
					height: 100%;
					background: url(/static/images/committee.svg) no-repeat;
					background-size: 70%;
					opacity: 0.2;
				}

				.van-icon {
					color: #f9d423;
				}
			}

			&.property {
				background-color: #dcd9d4;
				background-image: linear-gradient(
						180deg,
						hsla(0, 0%, 100%, 0.5) 0,
						rgba(0, 0, 0, 0.5)
					),
					radial-gradient(
						at 50% 0,
						hsla(0, 0%, 100%, 0.1) 0,
						rgba(0, 0, 0, 0.5) 50%
					);
				background-blend-mode: soft-light, screen;

				position: relative;
				overflow: hidden;
				&::before {
					content: " ";
					position: absolute;
					top: 45%;
					left: 45%;
					width: 100%;
					height: 100%;
					background: url(/static/images/property.svg) no-repeat;
					background-size: 60%;
					opacity: 0.2;
				}

				.van-icon {
					color: rgba(0, 0, 0, 0.5);
				}
			}
		}
	}

	.subject {
		background-color: white;
		padding: 10px;
		height: 186px;
		margin-top: 5px;

		.banner {
			width: 100%;
			height: 167px;
		}

		p {
			text-indent: 2em;
			font-size: 15px;
			line-height: 21px;
			letter-spacing: 1px;
			margin: 5px 0px;
		}

		.new-logo {
			width: 185px;
		}

		.red-style {
			color: rgb(172, 13, 13);
		}
	}

	.logos {
		.van-image {
			width: 35px;
			height: 35x;
			margin-right: 5px;

			&.sscisa {
				transform: scale(1.15);
			}
		}
	}

	.bottom {
		position: absolute;
		bottom: 0px;
		left: 0px;
		width: 100%;
		padding: 10px;
		background-color: @main;
		z-index: 1000;

		.text {
			color: #9c690a;
			text-align: center;
		}

		.text1 {
			font-size: 15px;
			line-height: 19px;
		}

		.text2 {
			font-size: 12px;
		}
	}

	.flash {
		transform-origin: center;
		animation: flash 1s ease-in-out;
		animation-direction: alternate-reverse;
		animation-iteration-count: infinite;
	}
}

@keyframes flash {
	from {
		transform: scale(0.7);
		opacity: 0.5;
	}

	to {
		transform: scale(1.3);
		opacity: 1;
	}
}
</style>
